(function () {
  'use strict';

  var FORM_SELECTOR = '[data-modobloom-direct-main-form], [data-modobloom-direct-addon-form]';

  function emit(name, detail) {
    document.dispatchEvent(new CustomEvent(name, { detail: detail || {} }));
  }

  function getText(root, selector) {
    var element = root ? root.querySelector(selector) : null;
    return element ? element.textContent.trim() : '';
  }

  function getImage(root) {
    var image = root
      ? (root.matches && root.matches('img') ? root : root.querySelector('img'))
      : null;
    return image ? image.currentSrc || image.src || '' : '';
  }

  function getCartContext(form) {
    var card = form.closest('[data-modobloom-direct-addon-card]');
    var purchase = form.closest('[data-dc-purchase], [data-gc-purchase], .dc-purchase, .gc-purchase');
    var mainImage = purchase
      ? purchase.querySelector('[data-dc-main-image], [data-gc-main-image], .dc-purchase__main-image, .gc-purchase__main-image')
      : null;

    return {
      title: getText(card, 'strong, h3') || getText(purchase, '.dc-purchase__title, .gc-purchase__title'),
      variant: getText(card, '[data-gc-addon-option-name], [data-dc-addon-option-name]')
        || getText(purchase, '[data-gc-option][aria-checked="true"] strong, [data-dc-color-label]'),
      price: getText(card, '[data-gc-addon-price], .dc-purchase__addon-price')
        || getText(purchase, '[data-dc-main-price], [data-gc-main-price]'),
      image: getImage(card) || getImage(mainImage)
    };
  }

  function setLoading(button, loading) {
    if (!button) return;
    button.disabled = loading;
    button.classList.toggle('is-loading', loading);
    button.setAttribute('aria-busy', loading ? 'true' : 'false');
  }

  function openCartDrawer() {
    if (window.CustomCartDrawer && typeof window.CustomCartDrawer.open === 'function') {
      window.CustomCartDrawer.open({ skipRefresh: true, source: 'modobloom' });
      return;
    }

    document.dispatchEvent(new CustomEvent('cart:open', {
      detail: { force: true, source: 'modobloom' }
    }));
  }

  function prepareCart(variantId) {
    if (window.CustomCartDrawer && typeof window.CustomCartDrawer.prepareForAdd === 'function') {
      return window.CustomCartDrawer.prepareForAdd(variantId);
    }
    return Promise.resolve();
  }

  function mutateCart(action) {
    if (window.CustomCartDrawer && typeof window.CustomCartDrawer.mutate === 'function') {
      return window.CustomCartDrawer.mutate(action);
    }

    return Promise.resolve().then(action);
  }

  function renderAddedItem(lineItem) {
    emit('modobloom:cart:add-confirmed', lineItem);

    if (window.CustomCartDrawer && typeof window.CustomCartDrawer.renderAddedLineItem === 'function') {
      window.CustomCartDrawer.renderAddedLineItem(lineItem);
      return;
    }

    emit('modobloom:cart:add-line-confirmed', {
      lineItem: lineItem,
      variantId: lineItem && (lineItem.variant_id || lineItem.id)
    });
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }

  function resolveVariantId(form) {
    var input = form.querySelector('[name="id"]');
    var currentId = input ? String(input.value || '').trim() : '';
    if (currentId) return Promise.resolve(currentId);

    var purchase = form.closest('[data-dc-purchase], [data-gc-purchase], .dc-purchase, .gc-purchase');
    var selectedOption = purchase
      ? purchase.querySelector('[data-dc-variant].is-selected, [data-gc-option].is-selected')
      : null;
    var selectedId = selectedOption ? String(selectedOption.dataset.variantId || '').trim() : '';

    if (selectedId && input) {
      input.value = selectedId;
      input.setAttribute('value', selectedId);
      return Promise.resolve(selectedId);
    }

    var productJsonUrl = form.dataset.modobloomAddonProductJson || '';
    if (!productJsonUrl || !input) return Promise.resolve('');

    return fetch(productJsonUrl, {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Product lookup failed');
      return response.json();
    }).then(function (product) {
      var variants = product && Array.isArray(product.variants) ? product.variants : [];
      var variant = variants.find(function (item) { return item.available; });
      if (!variant || !variant.id) throw new Error('No available product variant');
      input.value = variant.id;
      return String(variant.id);
    });
  }

  function addForm(form) {
    var formData = new FormData(form);
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

    return fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) {
          throw new Error(data.description || data.message || 'Add to cart failed');
        }
        return data;
      });
    });
  }

  function bind(form) {
    if (!form || form.dataset.modobloomDirectAddonBound === 'true') return;
    form.dataset.modobloomDirectAddonBound = 'true';

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      event.stopPropagation();

      var button = event.submitter || form.querySelector(
        '[data-modobloom-direct-addon-button], [data-dc-main-add], [data-gc-main-add]'
      );
      var context = getCartContext(form);

      if (!button || button.getAttribute('aria-busy') === 'true') return;

      setLoading(button, true);
      resolveVariantId(form)
        .then(function (variantId) {
          if (!variantId) throw new Error('Missing variant id');

          openCartDrawer();
          emit('modobloom:cart:adding', {
            variantId: variantId,
            title: context.title,
            variant: context.variant,
            price: context.price,
            image: context.image
          });

          return mutateCart(function () {
            return prepareCart(variantId).then(function () {
              return addForm(form);
            });
          });
        })
        .then(renderAddedItem)
        .catch(function (error) {
          console.error('Direct add failed:', error);
          emit('modobloom:cart:add-cancelled');
        })
        .finally(function () {
          setLoading(button, false);
        });
    });
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(FORM_SELECTOR).forEach(bind);
  }

  if (!window.ModoBloomDirectAddonCart) {
    window.ModoBloomDirectAddonCart = { init: init };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
    } else {
      init(document);
    }
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  } else {
    window.ModoBloomDirectAddonCart.init(document);
  }
})();
